import React, { useState } from 'react';

import { IconButton } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import { Close as CloseIcon } from '@material-ui/icons';
import WarningIcon from '@material-ui/icons/Warning';
import classnames from 'classnames';

export const styles = ({
  spacing: { unit },
  palette: {
    common: { white },
    primary: { main },
  },
  custom: {
    palette: { colorAccentPeach, colorAccentWatermelon },
  },
}: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: `0 ${unit}px`,
      backgroundColor: colorAccentPeach,
    },
    bannerContent: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      margin: unit * 2,
    },
    warningIcon: {
      color: colorAccentWatermelon,
    },
    primaryColor: {
      backgroundColor: main,
      color: white,
      '& > *': {
        color: `${white} !important`,
        '& > p': {
          color: `${white} !important`,
        },
      },
    },
  });

export interface BannerProps extends WithStyles<typeof styles>, React.HTMLAttributes<HTMLDivElement> {
  variant?: 'warning';
  color?: 'primary';
  hideCloseOption?: boolean;
  onClose?: () => any;
}

const Banner: React.FC<BannerProps> = ({ classes, children, variant, color, onClose, hideCloseOption, ...rest }) => {
  const [dismissed, setDismissed] = useState(false);
  const usePrimaryColor = color === 'primary';
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setDismissed(true);
  };
  if (dismissed) return null;

  return (
    <div className={classnames({ [classes.root]: true, [classes.primaryColor]: usePrimaryColor })} {...rest}>
      <div className={classes.bannerContent}>
        {variant === 'warning' && (
          <div className={classes.icon}>
            <WarningIcon fontSize="small" className={classes.warningIcon} />
          </div>
        )}
        {children}
      </div>
      {!hideCloseOption && (
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      )}
    </div>
  );
};

export default withStyles(styles)(Banner);
